import React, { useMemo } from 'react';
import { Col, Row } from 'antd';

import { CardAttachments } from '../../../components/CardAttachments';
import { DadosDoMotorista } from '../DadosDoMotorista';

export function TabMotorista({
  data,
  imagens,
  spinningImg = false,
  openTab = () => {},
  carregarSolicitacaoAtual,
  indexImgMotorista = () => {},
  setSpinning,
  tipoValidacao,
}) {
  const motorista = useMemo(
    () => ({
      ...data?.pessoaFisicaCadastro,
      endereco: data?.endereco,
      dadosEndereco: data?.dadosEndereco,
      referencias: data?.referencias,
      telefone: data?.telefone || '',
    }),
    [data]
  );

  return (
    <Col
      style={{
        padding: '16px 0',
      }}
    >
      <Col>
        <Row>
          <CardAttachments
            updateList={openTab}
            handlerOpenImg={indexImgMotorista}
            imagens={imagens}
            spinning={spinningImg}
          />
        </Row>
      </Col>
      <Col justify="center" md={24} lg={24} xs={24}>
        {data && (
          <DadosDoMotorista
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            dadosMotorista={motorista}
            setSpinning={setSpinning}
            tipoValidacao={tipoValidacao}
          />
        )}
      </Col>
    </Col>
  );
}
